import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Modal from "react-modal";
import Icon from "backpack-ui/dist/components/icon";
import Overlay from "shared/components/Overlay";
import { SEARCH_HOST } from "../../../navigation/config";
import Input from "../../Input";
import Results from "../../Results";
import styles from "./styles.css";

class InputModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      // Modal is rendered outside the root element, so we need "offsetTop" to
      // position it along, when ads push whole GlobalHeader down.
      offsetTop: 0,
    };
  }

  componentDidMount() {
    this.headerNode = null;

    if (typeof document !== "undefined") {
      // "offsetTop" reference element
      this.headerNode = document.getElementById("global-header");
    }

    if (this.headerNode) {
      // Required by Modal component
      Modal.setAppElement(this.headerNode);
    }
  }

  getOffsetTop = () => {
    let offsetTop = 0;

    if (this.headerNode) {
      offsetTop = this.headerNode.getBoundingClientRect().top;
    }

    return offsetTop;
  };

  show = () => {
    this.setState({
      isVisible: true,
      offsetTop: this.getOffsetTop(),
    });
  };

  hide = () => {
    const { onRequestClose } = this.props;

    this.setState({ isVisible: false }, onRequestClose);
  };

  render() {
    const { isOpen, searchResults, searchTerm, onChange } = this.props;
    const { isVisible, offsetTop } = this.state;
    const inputId = "search-input-desktop";

    return (
      <Modal
        isOpen={isOpen}
        overlayClassName={styles.modalOverlay}
        style={{ overlay: { top: `${offsetTop}px` } }}
        className={cn({
          [styles.wrapper]: true,
          [styles.isVisible]: isVisible,
        })}
        shouldCloseOnOverlayClick={false}
        onRequestClose={this.hide}
        onAfterOpen={this.show}
        closeTimeoutMS={400}
      >
        <Overlay onClick={this.hide} style={{ top: `${offsetTop}px` }} />

        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.inner}>
              <form action={SEARCH_HOST}>
                <Icon.Search label="Search" className={styles.searchIcon} />
                <Input
                  id={inputId}
                  name="q"
                  defaultValue={searchTerm}
                  placeholder="Search places, cities, countries and continents"
                  className={styles.input}
                  tabIndex="0"
                  autoFocus
                  onChange={onChange}
                  value={searchTerm}
                />
                <button
                  type="button"
                  title="Close search"
                  className={styles.closeButton}
                  onClick={this.hide}
                  tabIndex="0"
                >
                  <Icon.Close label="Close" className={styles.closeIcon} />
                </button>
              </form>
            </div>
            {searchResults.length > 0 && (
              <Results searchResults={searchResults} searchTerm={searchTerm} />
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

InputModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  searchResults: PropTypes.arrayOf(PropTypes.shape({})),
};

InputModal.defaultProps = {
  searchTerm: "",
  searchResults: [],
};

export default InputModal;
